import { render, staticRenderFns } from "./createInfo.vue?vue&type=template&id=f20e6a80&scoped=true"
import script from "./createInfo.vue?vue&type=script&lang=js"
export * from "./createInfo.vue?vue&type=script&lang=js"
import style0 from "./createInfo.vue?vue&type=style&index=0&id=f20e6a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20e6a80",
  null
  
)

export default component.exports